/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminCreateRequest } from '../backend/model';
// @ts-ignore
import type { ApiResponseAdminDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListAdminAuditLogDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListAdminDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseUser } from '../backend/model';
// @ts-ignore
import type { ApiResponseVoid } from '../backend/model';
// @ts-ignore
import type { CreateAdminRequest } from '../backend/model';
// @ts-ignore
import type { UpdateAdminRequest } from '../backend/model';
/**
 * CouncilAdminApi - axios parameter creator
 * @export
 */
export const CouncilAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} councilId 
         * @param {CreateAdminRequest} createAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouncilAdmin: async (councilId: number, createAdminRequest: CreateAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('createCouncilAdmin', 'councilId', councilId)
            // verify required parameter 'createAdminRequest' is not null or undefined
            assertParamExists('createCouncilAdmin', 'createAdminRequest', createAdminRequest)
            const localVarPath = `/api/admin/council/{councilId}/admins`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} councilId 
         * @param {AdminCreateRequest} adminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouncilAdminV2: async (councilId: number, adminCreateRequest: AdminCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('createCouncilAdminV2', 'councilId', councilId)
            // verify required parameter 'adminCreateRequest' is not null or undefined
            assertParamExists('createCouncilAdminV2', 'adminCreateRequest', adminCreateRequest)
            const localVarPath = `/api/admin/council/{councilId}/admins/v2`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCouncilAdmin: async (councilId: number, adminId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('deleteCouncilAdmin', 'councilId', councilId)
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('deleteCouncilAdmin', 'adminId', adminId)
            const localVarPath = `/api/admin/council/{councilId}/admins/{adminId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAdmin: async (councilId: number, adminId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilAdmin', 'councilId', councilId)
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('getCouncilAdmin', 'adminId', adminId)
            const localVarPath = `/api/admin/council/{councilId}/admins/{adminId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAdminAuditLogs: async (councilId: number, adminId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilAdminAuditLogs', 'councilId', councilId)
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('getCouncilAdminAuditLogs', 'adminId', adminId)
            const localVarPath = `/api/admin/council/{councilId}/admins/{adminId}/audit-logs`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAdmins: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilAdmins', 'councilId', councilId)
            const localVarPath = `/api/admin/council/{councilId}/admins`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {UpdateAdminRequest} updateAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncilAdmin: async (councilId: number, adminId: number, updateAdminRequest: UpdateAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('updateCouncilAdmin', 'councilId', councilId)
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('updateCouncilAdmin', 'adminId', adminId)
            // verify required parameter 'updateAdminRequest' is not null or undefined
            assertParamExists('updateCouncilAdmin', 'updateAdminRequest', updateAdminRequest)
            const localVarPath = `/api/admin/council/{councilId}/admins/{adminId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilAdminApi - functional programming interface
 * @export
 */
export const CouncilAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} councilId 
         * @param {CreateAdminRequest} createAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCouncilAdmin(councilId: number, createAdminRequest: CreateAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCouncilAdmin(councilId, createAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminApi.createCouncilAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} councilId 
         * @param {AdminCreateRequest} adminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCouncilAdminV2(councilId: number, adminCreateRequest: AdminCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAdminDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCouncilAdminV2(councilId, adminCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminApi.createCouncilAdminV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCouncilAdmin(councilId: number, adminId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCouncilAdmin(councilId, adminId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminApi.deleteCouncilAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilAdmin(councilId: number, adminId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAdminDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilAdmin(councilId, adminId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminApi.getCouncilAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilAdminAuditLogs(councilId: number, adminId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListAdminAuditLogDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilAdminAuditLogs(councilId, adminId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminApi.getCouncilAdminAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilAdmins(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListAdminDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilAdmins(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminApi.getCouncilAdmins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {UpdateAdminRequest} updateAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouncilAdmin(councilId: number, adminId: number, updateAdminRequest: UpdateAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAdminDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouncilAdmin(councilId, adminId, updateAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAdminApi.updateCouncilAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilAdminApi - factory interface
 * @export
 */
export const CouncilAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {number} councilId 
         * @param {CreateAdminRequest} createAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouncilAdmin(councilId: number, createAdminRequest: CreateAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseUser> {
            return localVarFp.createCouncilAdmin(councilId, createAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} councilId 
         * @param {AdminCreateRequest} adminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCouncilAdminV2(councilId: number, adminCreateRequest: AdminCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAdminDTO> {
            return localVarFp.createCouncilAdminV2(councilId, adminCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCouncilAdmin(councilId: number, adminId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.deleteCouncilAdmin(councilId, adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAdmin(councilId: number, adminId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAdminDTO> {
            return localVarFp.getCouncilAdmin(councilId, adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAdminAuditLogs(councilId: number, adminId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListAdminAuditLogDTO> {
            return localVarFp.getCouncilAdminAuditLogs(councilId, adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAdmins(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListAdminDTO> {
            return localVarFp.getCouncilAdmins(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} councilId 
         * @param {number} adminId 
         * @param {UpdateAdminRequest} updateAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncilAdmin(councilId: number, adminId: number, updateAdminRequest: UpdateAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAdminDTO> {
            return localVarFp.updateCouncilAdmin(councilId, adminId, updateAdminRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilAdminApi - object-oriented interface
 * @export
 * @class CouncilAdminApi
 * @extends {BaseAPI}
 */
export class CouncilAdminApi extends BaseAPI {
    /**
     * 
     * @param {number} councilId 
     * @param {CreateAdminRequest} createAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminApi
     */
    public createCouncilAdmin(councilId: number, createAdminRequest: CreateAdminRequest, options?: RawAxiosRequestConfig) {
        return CouncilAdminApiFp(this.configuration).createCouncilAdmin(councilId, createAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} councilId 
     * @param {AdminCreateRequest} adminCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminApi
     */
    public createCouncilAdminV2(councilId: number, adminCreateRequest: AdminCreateRequest, options?: RawAxiosRequestConfig) {
        return CouncilAdminApiFp(this.configuration).createCouncilAdminV2(councilId, adminCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} councilId 
     * @param {number} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminApi
     */
    public deleteCouncilAdmin(councilId: number, adminId: number, options?: RawAxiosRequestConfig) {
        return CouncilAdminApiFp(this.configuration).deleteCouncilAdmin(councilId, adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} councilId 
     * @param {number} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminApi
     */
    public getCouncilAdmin(councilId: number, adminId: number, options?: RawAxiosRequestConfig) {
        return CouncilAdminApiFp(this.configuration).getCouncilAdmin(councilId, adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} councilId 
     * @param {number} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminApi
     */
    public getCouncilAdminAuditLogs(councilId: number, adminId: number, options?: RawAxiosRequestConfig) {
        return CouncilAdminApiFp(this.configuration).getCouncilAdminAuditLogs(councilId, adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminApi
     */
    public getCouncilAdmins(councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilAdminApiFp(this.configuration).getCouncilAdmins(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} councilId 
     * @param {number} adminId 
     * @param {UpdateAdminRequest} updateAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAdminApi
     */
    public updateCouncilAdmin(councilId: number, adminId: number, updateAdminRequest: UpdateAdminRequest, options?: RawAxiosRequestConfig) {
        return CouncilAdminApiFp(this.configuration).updateCouncilAdmin(councilId, adminId, updateAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

